import {isNode} from 'service/html.service';

class E3Tooltip {
    _elements = {};
    _tooltip = {
        element: null,
        title: null
    };
    _options = {
        delay: 500,
        className: 'e3-tooltip',
        loadingClassName: 'e3-tooltip--loading',
        titleTag: 'p'
    };

    constructor(options = {}) {
        this._prepareOptions(options);
        this._init();
    }

    _prepareOptions(opts) {
        Object.keys(this._options).forEach((key) => {
            if (opts.hasOwnProperty(key)) this._options[key] = opts[key];
        });
    }

    _init() {
        let {className, titleTag} = this._options;
        let title = document.createElement(titleTag);
        this._tooltip.element = document.createElement('div');

        this._tooltip.element.classList.add(className);
        this._tooltip.element.appendChild(title);

        this._tooltip.title = title;
    }

    _bindEvents(name) {
        let element = this._elements[name].element;
        let mouseenter = this._onMouseEnter.bind(this, name);
        let mouseleave = this._onMouseLeave.bind(this, name);

        this._elements[name].mouseenter = mouseenter;
        this._elements[name].mouseleave = mouseleave;

        element.addEventListener('mouseenter', mouseenter);
        element.addEventListener('mouseleave', mouseleave);
    }

    _unbindEvents(name) {
        let element = this._elements[name].element;
        let mouseenter = this._elements[name].mouseenter;
        let mouseleave = this._elements[name].mouseleave;

        element.removeEventListener('mouseenter', mouseenter);
        element.removeEventListener('mouseleave', mouseleave);
    }

    _onMouseEnter(name) {
        let element = this._elements[name].element;
        let {title, align} = this._elements[name];

        if (!element) return;

        this._tooltip.title.innerText = title;
        this._tooltip.element.classList.add(align);

        element.appendChild(this._tooltip.element);

    }

    _onMouseLeave(name) {
        let element = this._elements[name].element;
        let {align} = this._elements[name];

        if (!element) return;

        try {
            if(!isNode(this._tooltip.element)) return ;
            element.removeChild(this._tooltip.element);
        } catch (e) {
            console.log(e);

            return;
        }

        this._tooltip.element.classList.remove(align);
        this._tooltip.title.innerText = '';
    }

    add(name, element, title, align = 'center') {
        this._elements[name] = {element, title, align};
        this._bindEvents(name);
    }

    remove(name) {
        this._unbindEvents(name);
        delete this._elements[name];
    }

    destroy() {
        Object.keys(this._elements).forEach((key) => this.remove(key));
    }
}

export default E3Tooltip;
